module.exports = __webpack_public_path__ + "static/media/vertical-menu.63eae674.svg";